import {
  IWorkloadCounts,
  PATIENT_STATUS,
  workloadPatientStatus,
} from "@home-health-notify/domain";

import { getGroupStatusProperty } from "hhn-commons";
import React from "react";
import PatientHomeIcon from "../../../../../common/PatientHomeIcon";
import {
  PatientStatusCount,
  PatientStatusItemWrapper,
  PatientStatusWrapper,
} from "../AdvanceSearchList.style";

type PatientStatusCountsProps = {
  userId: string;
  workloadCounts: IWorkloadCounts;
};

const PatientStatusCounts = ({
  userId,
  workloadCounts,
}: PatientStatusCountsProps) => {
  const patientStatus: PATIENT_STATUS[] = [
    PATIENT_STATUS.PENDING_SOC,
    PATIENT_STATUS.HOSPITALIZED,
    PATIENT_STATUS.PENDING_ROC,
  ];

  return (
    <PatientStatusWrapper>
      {patientStatus.map((status: PATIENT_STATUS) => {
        const statusTitle = getGroupStatusProperty(+status).title;
        return (
          <PatientStatusItemWrapper key={`${userId}-${status}`}>
            <div style={{ marginRight: 7 }} data-testid={`${statusTitle.toLowerCase()}-status-img`}>
              <PatientHomeIcon
                size={30}
                status={+status}
              />
            </div>
            <PatientStatusCount
              data-testid={`${statusTitle.toLowerCase()}-status-count`}
            >
              {
                workloadCounts[
                  workloadPatientStatus[status] as keyof IWorkloadCounts
                ]
              }
            </PatientStatusCount>
          </PatientStatusItemWrapper>
        );
      })}
    </PatientStatusWrapper>
  );
};

export default PatientStatusCounts;
